import { render } from "./PaginatedDropDown.vue?vue&type=template&id=071b4212"
import script from "./PaginatedDropDown.vue?vue&type=script&lang=js"
export * from "./PaginatedDropDown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__